import * as React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import MainLayoutContainer from 'containers/MainLayout'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import ReportsTable from './components/Table'
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'
// context
import { PowerBIReportsAPIContext } from 'containers/PowerBIReports/layers/API'

const PowerBIReports: React.FC = () => {
  const { isLoading } = React.useContext(PowerBIReportsAPIContext)

  return (
    <>
      <Helmet>
        <title>Skefto - Power BI</title>
      </Helmet>
      <MainLayoutContainer isLoading={isLoading} label={'Power BI'} CTA={null}>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <ReportsTable />
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default PowerBIReports
